import { ReloadOutlined } from '@ant-design/icons';
import { OrderStatusCode } from '@gooduncles/gu-app-schema';
import { Button, Checkbox, message } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FC, useEffect, useMemo, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { getMessageWrapper } from 'src/utils/supplier-purchase-order-util';

import { useCommerceConf } from 'src/redux/hooks/useCommerceConf';

import useSWRProductSuppliers from 'src/hooks/swr/useSWRProductSuppliers';
import useSWRPurchaseOrderPreview from 'src/hooks/swr/useSWRPurchaseOrderPreview';
import { useTitle } from 'src/hooks/useTitle';

import SupplierPurchaseOrderPreviewTable from 'src/atomic-components/organisms/Tables/SupplierPurchaseOrderPreviewTable';

const PurchaseOrderPreview: FC = () => {
  useTitle('발주 관리 - 발주 미리보기');
  const [showHeader, setShowHeader] = useState(false);
  const [includeSubmitted, setIncludeSubmitted] = useState<boolean>(false);
  const { getDeliveryDate } = useCommerceConf();

  const messageWrapper = useMemo(() => {
    const date = getDeliveryDate();
    return getMessageWrapper(date);
  }, [getDeliveryDate]);

  const onChangeShowHeader = (e: CheckboxChangeEvent) => setShowHeader(e.target.checked);
  const onChangeIncludeSubmitted = (e: CheckboxChangeEvent) => setIncludeSubmitted(e.target.checked);
  const {
    data,
    isLoading,
    error,
    refresh: refreshPurchaseOrderPreview,
  } = useSWRPurchaseOrderPreview(
    includeSubmitted ? [OrderStatusCode.SUBMITTED, OrderStatusCode.ACCEPTED] : [OrderStatusCode.ACCEPTED]
  );
  const {
    productSuppliers,
    isLoading: isLoadingProductSuppliers,
    refresh: refreshProductSuppliers,
  } = useSWRProductSuppliers([]);
  const rowData = useMemo(
    () =>
      data?.map((item) => {
        const productSupplier = productSuppliers?.find((supplier) => supplier._id === item.supplierId);
        if (!productSupplier) {
          console.log(item.supplierId);
          console.log(item);
        }
        return {
          ...item,
          productSupplier: productSupplier,
        };
      }) ?? [],
    [data, productSuppliers]
  );

  const refreshAll = () => {
    refreshPurchaseOrderPreview();
    refreshProductSuppliers();
  };

  useEffect(() => {
    if (error) {
      const errorMessage = errorObjectToString(error);
      message.error(errorMessage);
    }
  }, [error]);
  return (
    <div className='height100 flexColumn'>
      <div className='flexColumn'>
        <div className='flexRow flexAlignCenter flexSpaceBetween'>
          <Button onClick={refreshAll} loading={isLoading || isLoadingProductSuppliers} icon={<ReloadOutlined />}>
            새로고침
          </Button>
          <div>
            <Checkbox checked={showHeader} onChange={onChangeShowHeader}>
              머릿말 표시
            </Checkbox>
            <Checkbox checked={includeSubmitted} onChange={onChangeIncludeSubmitted}>
              수락대기 주문 포함
            </Checkbox>
          </div>
        </div>
        <p>
          • 오늘의 주문과 거래처 정보에 따른 발주서를 미리볼 수 있습니다.
          <br />• 미생성된 발주내용으로 편집이 불가능합니다.
        </p>
      </div>
      <SupplierPurchaseOrderPreviewTable rowData={rowData} showHeader={showHeader} messageWrapper={messageWrapper} />
    </div>
  );
};

export default PurchaseOrderPreview;
